import { createContext } from 'react';

import TemplatesRootStore from '../templates-root-store';

export const TemplatesStoreContext = createContext<TemplatesRootStore>(undefined as unknown as TemplatesRootStore);
export const StoreProvider = TemplatesStoreContext.Provider;
